<template lang="pug">
  div(class="d-flex justify-end mb-1")
    template(v-if="isLoading")
      span(class="text-12px pr-2 color-primary") {{ $t(loadingText) }}
      v-progress-circular(
        width="2"
        size="20"
        color="#8F257D"
        :indeterminate="true"
      )
    template(v-else-if="isErrorStatus")
      e-svg-icon close-circle-red
    template(v-else-if="isSuccessStatus")
      span(class="text-12px pr-2 color-success") {{ $t(passedText) }}
      e-svg-icon check-circle-green
    template(v-else)
      v-progress-circular(
        width="2"
        size="20"
      )
</template>

<script>
export default {
  name: 'BlockDocumentsListItemStatusIcon',
  props: {
    document: {
      type: Object,
      default: () => ({})
    },
    documentsStates: {
      type: Object,
      default: () => ({})
    },
    statuses: {
      type: Object,
      default: () => ({})
    },
    loadingText: {
      type: String,
      default: 'In progress'
    },
    passedText: {
      type: String,
      default: 'Done'
    }
  },
  computed: {
    isLoading() {
      return this._.get(this.documentsStates[this.document.id], 'loading', false)
    },
    isErrorStatus() {
      return this._.get(this.documentsStates[this.document.id], 'status') === this.statuses.error
    },
    isSuccessStatus() {
      return this._.get(this.documentsStates[this.document.id], 'status') === this.statuses.success
    }
  }
}
</script>

<style scoped lang="scss"></style>
